export default {
	CLEAR: "parcelamentoTaxaAdminClear",
	SET: "parcelamentoTaxaAdminSet",
};
